import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-skip-one-backward.tsx
/**
* icon.24.skip.one.backward
*
* Keywords: triangle, right, forward, next, chevron, directional, navigation, proceed
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE3LjUgNi41YS41LjUgMCAwIDAtLjUuNXYxMGEuNS41IDAgMCAwIDEgMFY3YS41LjUgMCAwIDAtLjUtLjVtLTIuNDk5IDEuNjAzYTEuNiAxLjYgMCAwIDAtMi40MDQtMS4zODRMNS43NDcgMTAuN2ExLjUgMS41IDAgMCAwIDAgMi41OTRsNi44NSAzLjk4MUExLjYgMS42IDAgMCAwIDE1IDE1Ljg5NHptLTEuOTAxLS41MmEuNi42IDAgMCAxIC45MDEuNTJ2Ny43OWEuNi42IDAgMCAxLS45MDEuNTJMNi4yNDggMTIuNDNhLjUuNSAwIDAgMSAwLS44NjR6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=24950-58397
*/
const Icon24SkipOneBackward = memo(function Icon24SkipOneBackward(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M17.5 6.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 1 0V7a.5.5 0 0 0-.5-.5m-2.499 1.603a1.6 1.6 0 0 0-2.404-1.384L5.747 10.7a1.5 1.5 0 0 0 0 2.594l6.85 3.981A1.6 1.6 0 0 0 15 15.894zm-1.901-.52a.6.6 0 0 1 .901.52v7.79a.6.6 0 0 1-.901.52L6.248 12.43a.5.5 0 0 1 0-.864z"
		})
	});
});
//#endregion
export { Icon24SkipOneBackward };

//# sourceMappingURL=icon-24-skip-one-backward.js.map